module.exports = __webpack_public_path__ + "img/driver1.b0c7cb51.jpeg";